//API BACKEND
export const EXTERNAL_CONTEXT = '/ext';

//FRONTEND
export const INTERNAL_CONTEXT = '/interno';
const SERVICES_LINES = '/services/lines';

export const URLS = {
  START: '/',
  LOGIN: '/login',
  LOGS: '/logs',
  RESET_PASSWORD: '/reset-password/:user/:password',
  SERVICES: '/services',
  SURVEY: '/services/survey',
  INSPECTION_REPORT: '/services/report',
  PORTAL_ACCESS: '/portal-access',
  CHANGE_EMAIL: '/change-email',
  REGISTRATION: '/services/registration',
  COMPANY_SELECT: '/company/select',
  COMPANY: '/company',
  COMPANY_USERS: '/company/users',
  VEHICLES: '/services/vehicles',
  VEHICLE_CHANGE: '/services/vehicles/change',
  INFRACTIONS: '/services/infractions',
  LICENSES_EVENTUAL: '/services/licenses/eventual',
  LICENSES_LINKED: '/services/licenses/linked',
  LICENSES_CHARTER: '/services/licenses/charter',
  LICENSES_HEALTH: '/services/licenses/health',
  LICENSES_STUDENTS: '/services/licenses/students',
  LICENSES_SCHOOL: '/services/licenses/school',
  LICENSES_TOURISM: '/services/licenses/tourism',
  LICENSES_DUPLICATE: '/services/licenses/duplicate',

  SLIC_LINES_MODIFY_SCHEDULE: `${SERVICES_LINES}/slic-modify-schedule`,
  SLIC_LINES_EXPAND_SCHEDULE: `${SERVICES_LINES}/slic-expand-schedule`,
  SLIC_LINES_SUPRESS_SCHEDULE: `${SERVICES_LINES}/slic-supress-schedule`,
  SLIC_LINES_CHANGE_VEHICLE: `${SERVICES_LINES}/slic-change-vehicle`,
  SLIC_LINES_EXPIRATION_EXTENSION: `${SERVICES_LINES}/slic-expiration-extension`,
  SLIC_LINES_TRANSFER_PERMISSION: `${SERVICES_LINES}/slic-transfer-permission`,
  SLIC_LINES_CANCEL_PERMISSION: `${SERVICES_LINES}/slic-cancel-permission`,
  SLIC_LINES_SUBSTITUTE_CONDUCTOR: `${SERVICES_LINES}/slic-substitute-conductor`,

  STRIP_LINES_LINE_EXTENSION: `${SERVICES_LINES}/strip-line-extension`,
  STRIP_LINES_LINE_REDUCTION: `${SERVICES_LINES}/strip-line-reduction`,
  STRIP_LINES_SCHEDULE_REINFORCEMENT: `${SERVICES_LINES}/strip-line-schedule-reinforcement`,
  STRIP_LINES_LINE_CONNECTION: `${SERVICES_LINES}/strip-line-connection`,
  STRIP_LINES_DEFINITIVE_ITINERARY_CHANGE: `${SERVICES_LINES}/strip-definitive-itinerary-change`,
  STRIP_LINES_TEMPORARY_ITINERARY_CHANGE: `${SERVICES_LINES}/strip-temporary-itinerary-change`,
  STRIP_EQUIPMENT_TYPE_INCLUSION: `${SERVICES_LINES}/strip-equipment-type-inclusion`,
  STRIP_EQUIPMENT_TYPE_REPLACEMENT: `${SERVICES_LINES}/strip-equipment-type-replacement`,
  STRIP_SECTION_IMPLANTATION: `${SERVICES_LINES}/strip-section-implantation`,
  STRIP_SECTION_SUPPRESSION: `${SERVICES_LINES}/strip-section-suppression`,
  STRIP_LINES_LINE_CANCEL: `${SERVICES_LINES}/strip-line-cancel`,
  STRIP_SERVICE_CANCEL: `${SERVICES_LINES}/strip-service-cancel`,
  STRIP_SCHEDULES_MODIFICATION: `${SERVICES_LINES}/strip-schedules-modification`,
  STRIP_SCHEDULES_EXTENSION: `${SERVICES_LINES}/strip-schedules-extension`,
  STRIP_SCHEDULES_SUPPRESSION: `${SERVICES_LINES}/strip-schedules-suppression`,
  STRIP_DEADLINE_EXTENSION: `${SERVICES_LINES}/strip-deadline-extension`,
  STRIP_LINES_LINE_TRANSFER: `${SERVICES_LINES}/strip-line-transfer`,

  CHANGE_PASSWORD: '/change-password',
  LIST_VEHICLES: '/vehicles',
  LIST_INFRACTIONS: '/infractions',
  LIST_LICENSES: '/licenses',
  LIST_LINES: '/lines',

  AUDIT: `${INTERNAL_CONTEXT}/audit`,
  REPORTS: `${INTERNAL_CONTEXT}/reports`,

  SETTINGS: '/settings',
  WRONG: '/wrong',
  INTERNAL_REQUEST: `${INTERNAL_CONTEXT}/request/`,
  INTERNAL_REQUEST_DETAILS: `${INTERNAL_CONTEXT}/request/:cdSolicitacao`,
  NEW_REQUEST: `${INTERNAL_CONTEXT}/new`,
  MANUALS: `${INTERNAL_CONTEXT}/manuals`,

  LINES_MANAGE: `${INTERNAL_CONTEXT}/:isStrip?/lines/`,
  LINES_MANAGE_NEW: `${INTERNAL_CONTEXT}/:isStrip?/lines/new`,
  LINES_MANAGE_EDIT: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/edit`,

  LINES_MANAGE_PERMISSIONARIES: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/permissionaries`,
  LINES_MANAGE_PERMISSIONARIES_EDIT: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/permissionaries/:cdPermissionario/edit`,
  LINES_MANAGE_PERMISSIONARIES_NEW: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/permissionaries/new`,

  LINES_MANAGE_ITINERARIES: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/itineraries`,
  LINES_MANAGE_ITINERARIES_EDIT: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/itineraries/:cdItinerario/edit`,
  LINES_MANAGE_ITINERARIES_NEW: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/itineraries/new`,

  LINES_MANAGE_SCHEDULES: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/schedules`,
  LINES_MANAGE_SCHEDULES_EDIT: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/schedules/:cdQuadroHorario/edit`,
  LINES_MANAGE_SCHEDULES_NEW: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/schedules/new`,

  LINES_MANAGE_FARES: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/fares`,
  LINES_MANAGE_TRANSFERS: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/transfers`,

  LINES_MANAGE_CONDUCTORS: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/conductors`,
  LINES_MANAGE_CONDUCTORS_EDIT: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/conductors/:cdCondutorSubstituto/edit`,
  LINES_MANAGE_CONDUCTORS_NEW: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/conductors/new`,

  LINES_MANAGE_CONTRACT: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/contracts`,
  LINES_MANAGE_CONTRACT_EDIT: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/contracts/:cdContratoTermoAditivo/edit`,
  LINES_MANAGE_CONTRACT_NEW: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/contracts/new`,

  LINES_MANAGE_APOSTILLE: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/apostilles`,
  LINES_MANAGE_APOSTILLE_EDIT: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/apostilles/:cdLinhaApostila/edit`,
  LINES_MANAGE_APOSTILLE_NEW: `${INTERNAL_CONTEXT}/:isStrip?/lines/:cdLinha/apostilles/new`,
};
